import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { uiActions } from '@/store/slices/uiSlice';
import { useShortcut } from '@/hooks/useShortcut';
import { SIDEBAR_TOGGLE } from '@/lib/shortcuts';

const SIDEBAR_KEY = 'cv2:sidebar-collapsed';

export function readStoredSidebarCollapsed(): boolean {
  return localStorage.getItem(SIDEBAR_KEY) === 'true';
}

export function useSidebarCollapse() {
  const dispatch = useAppDispatch();
  const collapsed = useAppSelector((state) => state.ui.sidebarCollapsed);

  const toggle = useCallback(() => {
    const next = !collapsed;
    dispatch(uiActions.setSidebarCollapsed(next));
    localStorage.setItem(SIDEBAR_KEY, String(next));
  }, [collapsed, dispatch]);

  useShortcut({
    ...SIDEBAR_TOGGLE,
    onTrigger: toggle,
  });

  return { collapsed, toggle };
}
